import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class MenuCarousel extends HTMLElement {
  constructor() {
    super();

    // bindings

    // privates
    this._node = this;
    this._swiper_el = this._node.querySelector(".swiper");
    this._scrollbar = this._node.querySelector(".swiper-scrollbar");

    // events
    this._swiper = new Swiper(this._swiper_el, {
      a11y: false,
      speed: 333,
      loop: false,
      draggable: true,
      autoHeight: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      scrollbar: {
        el: this._scrollbar,
        hide: false,
        draggable: false,
        dragSize: 'auto'
      },
      keyboard: {
        enabled: false
      }
    });
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
  }
}
